import { render, staticRenderFns } from "./OverviewPerUserInformation.vue?vue&type=template&id=5a2c5423&"
import script from "./OverviewPerUserInformation.vue?vue&type=script&lang=ts&"
export * from "./OverviewPerUserInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports